__turbopack_context__.v({
  "fade-in": "MakersReserveHero-module-scss-module__8pvUia__fade-in",
  "headingGroup": "MakersReserveHero-module-scss-module__8pvUia__headingGroup",
  "hero": "MakersReserveHero-module-scss-module__8pvUia__hero",
  "heroImage": "MakersReserveHero-module-scss-module__8pvUia__heroImage",
  "image": "MakersReserveHero-module-scss-module__8pvUia__image",
  "inner": "MakersReserveHero-module-scss-module__8pvUia__inner",
  "lockup": "MakersReserveHero-module-scss-module__8pvUia__lockup",
  "lockupLogo": "MakersReserveHero-module-scss-module__8pvUia__lockupLogo",
  "root": "MakersReserveHero-module-scss-module__8pvUia__root",
  "title": "MakersReserveHero-module-scss-module__8pvUia__title",
});
